import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  return (
    <>
      <div className="lg:pl-60">
        <div className="sticky top-0 z-10 flex h-19 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
          <button
            type="button"
            className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
            onClick={() => setIsSidebarOpen((state) => !state)}
          >
            <span className="sr-only">Open sidebar</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              aria-hidden="true"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 10h16M4 14h16M4 18h16"
              ></path>
            </svg>
          </button>
          <div
            className="h-6 w-px bg-gray-900/10 lg:hidden"
            aria-hidden="true"
          ></div>
          <div className="flex flex-1 gap-x-4 items-center lg:gap-x-6">
            <div className="relative flex flex-1">
              <img className="w-[65px]" src="/logo.png" alt="TPE Logo" />
            </div>
          </div>
        </div>
        {/* outlet code */}
       
      </div>
      {/* sidebar */}
      <div className="relative z-50 lg:hidden" role="dialog" aria-modal="true">
        <div
          className={`${
            isSidebarOpen
              ? "fixed inset-0 bg-black bg-opacity-60 opacity-100"
              : "hidden"
          }`}
        ></div>
        <div
          className={`${isSidebarOpen ? "fixed inset-0 flex" : "hidden"}`}
        >
          <div
            className={`relative mr-16 flex w-full max-w-xs flex-1 ${
              isSidebarOpen ? "translate-x-0" : "-translate-x-full"
            } transition-all duration-200 ease-in-out`}
          >
            <div className="absolute left-full top-0 flex w-16 justify-center pt-5 opacity-100">
              <button
                type="button"
                className="-m-2.5 p-2.5"
                tabIndex={0}
                onClick={() => setIsSidebarOpen(false)}
              >
                <span className="sr-only">Close sidebar</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  aria-hidden="true"
                  className="h-6 w-6 text-white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>
            <Sidebar />
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
